import gql from 'graphql-tag';

export const ACCEPT_TERMS_AND_CONDITIONS = gql`
  mutation (
    $email: String,
    $title: String
    $firstName: String
    $lastName: String
    $middleName: String
    $dateOfBirth: String
    $phoneNumber: String
    $gender: Gender
    $address: String
    $externalId: String
    $orgId: Int!
    $token: String
    $locale: String
  ) {
    acceptTermsAndConditions (
      input: {
        email: $email
        title: $title
        firstName: $firstName
        lastName: $lastName
        middleName: $middleName
        dateOfBirth: $dateOfBirth
        phoneNumber: $phoneNumber
        gender: $gender
        address: $address
        locale: $locale
        orgId: $orgId
        externalId: $externalId,
        token: $token,
        otpMethod: INTERNAL_OTP
        userType: PATIENT
        externalIdType: POLICY
      },
    ) {
    jwt
      refreshToken
      tosRequired
      token

      session {
        sessionId

        user {
          userId
          profile {
            phoneNumber
            firstName
            lastName
            middleName
            dateOfBirth
            email
            avatar
            timezone
            policyId
            externalId
            isVerified
            isIdEligible
            title
            gender
            changePasswordRequired
          }

          dynamicPermissions {
            orgNodeId
            roleResources {
              resourceCode
              create
              read
              update
              delete
              assign
              children {
                resourceCode
                create
                read
                update
                delete
                assign
              }
            }
          }
        }

        permissions {
          orgNodeId
          roleResources {
            resourceCode
            create:
            read
            update
            delete
            assign
          }
        }
        activeConversations {
          appointmentId
          conversationId
        }
      }
    }
  }
`;
